import "../styles/general.css";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";

import MaskedInput from "react-text-mask";
import BrandSelect from "../components/brandselect/BrandSelect";
import DesktopView from "../components/desktopview/DesktopView";
import Header from "../components/header/Header";
import BlueLoader from "../components/loader/BlueLoader";
import MessageModals from "../components/modals/MessageModals";
import ModelSelect from "../components/modelselect/ModelSelect";
import globalContext from "../Contexts/GlobalContext";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import axios from "axios";
import React, { useRef, useEffect, useContext, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { SERVERMESSAGE } from "../constants/serverMessage";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import { addCommas, p2e, removeNonNumeric } from "../utils/functions";
import useRequestHeader from "../hooks/useRequestHeader";

export default function AddCarDetails() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;

  const navigate = useNavigate();
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();

  const [responseMessage, setResponseMessage] = useState("");

  // ----->
  const [isLoading, setIsLoading] = useState(false);
  // ----->

  //// inputs feild states start ////
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [prdY, setPrdY] = useState("");
  const [func, setFunc] = useState("");
  const [insuranceDate, setInsuranceDate] = useState("");
  const [lastReplace, setLastReplace] = useState("");
  const [avgFunc, setAvgFunc] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [frameNumber, setFrameNumber] = useState("");
  const [insuranceDateValue, setInsuranceDateValue] = useState();
  const [prDateValue, setPrDateValue] = useState();

  const [mustSendInsuranceDate, setMustSendInsuranceDate] = useState("");

  const [categoryID, setCategoryID] = useState("");
  //// inputs feild states end ////

  //// car details input handler start ////

  const brandHandle = (e) => {
    setBrand(e.target.value);
  };
  const modelHandle = (e) => {
    setModel(e.target.value);
  };
  const prdYHandle = (e) => {
    setPrdY(p2e(e.target.value));
  };
  const funcHandle = (e) => {
    setFunc(p2e(e.target.value));
  };
  const insuranceDateHandle = (e) => {
    setInsuranceDate(e.target.value);
  };
  const lastReplaceHandle = (e) => {
    setLastReplace(p2e(e.target.value));
  };
  const avgFuncHandle = (e) => {
    setAvgFunc(p2e(e.target.value));
  };
  const engineNumberHandle = (e) => {
    setEngineNumber(e.target.value);
  };
  const frameNumberHandle = (e) => {
    setFrameNumber(e.target.value);
  };
  //// car details input handler end ////

  const rgNewCar = () => {
    let cg = true;

    if (mustSendInsuranceDate.length !== 10) {
      cg = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(
        "تاریخ بیمه شخص ثالث را به درستی وارد نمایید"
      );
    }
    if (!lastReplace) {
      cg = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(" کیلومتر آخرین سرویس نمیتواند خالی باشد");
    }
    if (!func?.replaceAll(",", "")) {
      cg = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("کارکرد نمیتواند خالی باشد");
    }
    if (prDateValue?.year?.length < 4) {
      cg = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("سال تولید را به درستی انتخاب نمایید ");
    }
    if (!model) {
      cg = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("مدل خودرو  نمیتواند خالی باشد");
    }
    if (!brand) {
      cg = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("برند خودرو نمیتواند خالی باشد");
    }
    if (cg) {
      setIsLoading(true);
      const config = {
        headers: requestHeader,
      };
      axios
        .post(
          `${BASE_URL}/car/add`,
          {
            plate: contextData?.addNewCarPlate,
            company: brand,
            model: model,
            year: `${prDateValue?.year}`,
            kmCurrent: func.replaceAll(",", ""),
            category: `${categoryID}`,
            kmLastReplace: lastReplace?.replaceAll(",", ""),
            thirdInsurance: mustSendInsuranceDate,
          },
          config
        )
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              setCookies("plate", contextData?.addNewCarPlate);
              setCookies("kmCurrent", func?.replaceAll(",", ""), { path: "/" });
              contextData.setIsAfterAdd(true);
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(SERVERMESSAGE.successAddCar);
              removeCookies("logoUrlPices");
              navigate("/short-terms");
              break;
            }
            case SERVERMODE.DUPLICATE_CAR: {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(SERVERMESSAGE.DUPLICATE_CAR);
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
          setIsLoading(false);
        })
        .catch((err) => {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
          setIsLoading(false);
        });
    }
  };
  useEffect(() => {
    if (!contextData?.addNewCarPlate) {
      navigate("/add-car");
    }
  }, []);

  const [prDatePickerCalender, setPrDatePickerCalender] = useState(persian);

  const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  const datePickerRefInsurance = useRef();
  const datePickerRefPr = useRef();

  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div className="w-full   addCarDetailsBody min-[1024px]:hidden ">
        {contextData.isToastOpen && (
          <MessageModals
            message={contextData.toastMessage}
            setIsOpen={contextData.setIsToastOpen}
          />
        )}
        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute w-full h-full top-0  right-0 -z-50"
        />
        <Header relt={"relative"} />

        <div className="absolute w-full flex flex-col bottom-[24.5vw] top-[17.2vw] items-center justify-start ">
          <div className="w-full h-[19.22405660377358vw]  flex items-center justify-center">
            <div className="w-[92.45283018867925vw] h-[19.22405660377358vw]  flex items-center justify-between">
              <div className="w-[44.33962264150943vw] h-[19.22405660377358vw]">
                <svg
                  width="44.33962264150943vw"
                  height="19.22405660377358vw"
                  viewBox="0 0 588 256"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_49_22)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23.6413 27.6763C24.2474 27.6763 24.8536 27.6763 25.4598 27.6763C72.1361 24.0392 117.6 14.9464 160.639 1.00415H562.54C576.482 1.00415 587.394 11.9155 587.394 25.8578V230.748C587.394 244.085 576.482 255.602 562.54 255.602H25.4598C11.5175 255.602 0.606201 244.085 0.606201 230.748V52.5299C0.606201 39.8 10.3052 28.8887 23.6413 27.6763Z"
                      fill="#001D26"
                      fillOpacity="0.701961"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23.6413 27.6763C24.2474 27.6763 24.8536 27.6763 25.4598 27.6763C72.1361 24.0392 117.6 14.9464 160.639 1.00415H562.54C576.482 1.00415 587.394 11.9155 587.394 25.8578V230.748C587.394 244.085 576.482 255.602 562.54 255.602H25.4598C11.5175 255.602 0.606201 244.085 0.606201 230.748V52.5299C0.606201 39.8 10.3052 28.8887 23.6413 27.6763Z"
                      stroke="#00F7FF"
                      strokeWidth="0.606186"
                      strokeMiterlimit="2.61313"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M369.167 128.909V171.949C369.167 179.829 375.835 187.103 384.322 187.103C392.808 187.709 399.476 181.647 400.689 173.767H468.581V172.555L467.975 171.949C458.882 162.856 444.94 148.913 440.091 144.064C434.029 137.396 437.06 127.697 440.091 124.666C446.759 118.604 456.458 121.635 459.489 124.666L468.581 133.759V89.5073C468.581 80.4145 477.674 76.1712 481.918 76.1712C482.524 76.1712 482.524 76.1712 482.524 76.1712C478.28 71.9279 472.825 69.5032 466.763 69.5032H412.206C402.507 69.5032 394.021 75.565 390.99 85.264L383.715 108.299C375.229 111.33 369.167 119.817 369.167 128.909Z"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M468.581 86.4763H408.569L401.901 106.48H468.581"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M455.852 122.241C460.095 122.241 466.157 122.241 468.581 122.241"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M453.427 157.4H392.202C387.959 157.4 384.928 154.369 384.928 150.732C384.928 144.064 384.928 133.153 384.928 128.909C384.928 124.666 389.777 122.241 392.202 122.241C409.175 122.241 434.635 122.241 443.728 122.241"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M436.454 131.94H420.693V147.095H443.728"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M546.173 168.311V121.029C546.173 114.967 540.111 111.936 537.08 111.936C531.019 111.936 527.988 117.998 527.988 121.029C527.988 114.967 521.926 111.936 518.895 111.936C512.833 111.936 509.196 117.998 509.196 121.029C509.196 114.967 503.134 111.936 500.103 111.936C494.041 111.936 491.01 117.998 491.01 121.029V89.5073C491.01 83.4455 484.948 80.4146 481.918 80.4146C475.856 80.4146 472.825 86.4764 472.825 89.5073V139.821C472.825 140.427 472.219 141.639 471.612 141.639C471.006 142.245 470.4 141.639 469.794 141.033L456.458 127.697C452.214 123.454 445.546 125.878 443.728 127.697C438.878 131.94 441.303 138.608 443.728 141.033L471.006 168.918C472.219 169.524 472.825 171.342 472.825 172.555V181.648C472.825 183.466 473.431 184.678 474.643 185.891C475.856 187.103 477.068 187.709 478.887 187.709H526.775C537.687 187.709 546.173 178.617 546.173 168.311Z"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M395.233 139.215C395.233 134.971 398.87 131.334 403.113 131.334C407.357 131.334 410.994 134.971 410.994 139.215C410.994 144.064 407.357 147.701 403.113 147.701C398.87 147.701 395.233 143.458 395.233 139.215Z"
                      stroke="#00FFF2"
                      strokeWidth="3.03093"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M138.21 108.299C138.21 109.511 137.604 110.724 136.998 111.33C136.392 111.936 135.179 111.936 134.573 111.936C131.542 111.936 130.33 110.724 130.33 108.299C130.33 106.48 131.542 105.268 133.967 105.268C136.392 105.268 138.21 106.48 138.21 108.299ZM216.408 128.909C216.408 131.334 215.802 133.153 213.984 134.971C212.165 136.184 210.346 136.79 207.922 136.79H189.736L189.13 130.728H207.315C209.74 130.728 210.953 130.122 210.953 128.303C210.953 127.697 210.346 127.091 209.74 126.485L196.404 112.542L200.647 108.299L213.984 122.241C215.802 124.06 216.408 126.485 216.408 128.909ZM183.674 127.091C183.674 130.122 183.068 132.546 181.856 134.365C180.037 136.184 178.219 137.396 175.188 137.396C172.763 137.396 169.732 136.184 167.307 133.153C164.882 136.184 163.064 137.396 160.033 137.396C157.608 137.396 155.184 135.577 152.153 132.546C149.728 135.577 147.303 136.79 144.878 136.79H139.423C139.423 136.79 138.816 136.79 138.21 136.79H136.998C135.786 136.79 135.179 136.79 133.967 136.184C133.361 136.184 132.148 135.577 130.936 134.365C129.118 136.184 127.299 136.79 125.48 136.79H115.175H112.751H109.72L110.326 139.821C110.326 142.852 109.113 145.883 106.082 148.307C103.658 150.126 100.627 151.338 97.5959 151.338H88.5031C83.6536 151.338 80.0165 149.52 77.5918 146.489C75.167 143.458 73.9547 139.214 73.9547 134.365V124.06H79.4103V136.79C79.4103 139.821 80.6227 141.639 82.4412 143.458C84.2598 144.67 86.6845 145.883 89.7155 145.883H96.9897C99.4144 145.883 100.627 145.276 102.445 144.064C103.658 142.852 104.264 141.033 104.264 139.214C104.264 138.002 102.445 136.79 98.8083 136.79C98.2021 136.79 96.3835 136.79 92.1402 136.79L91.534 130.728H112.751H115.175H123.662C125.48 130.728 126.693 130.728 127.299 130.122C127.905 128.909 128.511 128.303 128.511 126.485V118.604H133.967V126.485C133.967 128.303 134.573 129.515 135.179 130.122C136.392 130.728 137.604 130.728 139.423 130.728H144.272C146.697 130.728 148.515 129.515 148.515 126.485V117.998H153.971V127.091C153.971 128.303 154.577 129.515 155.79 130.122C156.396 131.334 157.608 131.94 159.427 131.94C161.852 131.94 163.064 130.728 163.064 128.303V117.998H169.126V127.091C169.126 128.303 169.126 129.515 170.338 130.122C171.551 131.334 172.763 131.94 173.975 131.94C176.4 131.94 178.219 130.728 178.219 128.303V117.998H183.674V127.091ZM126.693 108.299C126.693 109.511 126.087 110.724 125.48 111.33C124.874 111.936 124.268 111.936 123.056 111.936C120.025 111.936 118.812 110.724 118.812 108.299C118.812 106.48 120.025 105.268 122.449 105.268C125.48 105.268 126.693 106.48 126.693 108.299Z"
                      fill="#00FFF2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_49_22">
                      <rect width="588" height="256" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="w-[44.33962264150943vw] h-[19.22405660377358vw]">
                <svg
                  width="44.33962264150943vw"
                  height="19.22405660377358vw"
                  viewBox="0 0 588 256"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_50_37)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M587.37 52.4539V229.987C587.37 243.837 576.039 255.169 562.188 255.169H25.182C11.9614 255.169 0.629517 243.837 0.629517 229.987V25.3833C0.629517 12.1627 11.9614 0.830811 25.182 0.830811H426.835C470.274 14.6809 515.602 23.4946 562.188 27.2719C562.818 27.2719 563.448 27.2719 564.077 27.2719C577.298 28.531 587.37 39.2334 587.37 52.4539Z"
                      fill="#001D26"
                      fillOpacity="0.701961"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M587.37 52.4539V229.987C587.37 243.837 576.039 255.169 562.188 255.169H25.182C11.9614 255.169 0.629517 243.837 0.629517 229.987V25.3833C0.629517 12.1627 11.9614 0.830811 25.182 0.830811H426.835C470.274 14.6809 515.602 23.4946 562.188 27.2719C562.818 27.2719 563.448 27.2719 564.077 27.2719C577.298 28.531 587.37 39.2334 587.37 52.4539Z"
                      stroke="#8F8C85"
                      strokeWidth="0.62955"
                      strokeMiterlimit="2.61313"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M395.358 138.702C395.358 134.295 399.135 130.518 403.542 130.518C407.949 130.518 411.726 134.295 411.726 138.702C411.726 143.739 407.949 146.886 403.542 146.886C399.135 146.886 395.358 143.739 395.358 138.702Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M402.283 105.966H477.829L471.533 85.8201H409.208L402.283 105.966Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M510.565 128.63C510.565 119.186 504.899 111.002 496.086 107.854L488.531 85.1906C486.013 75.7473 477.199 68.8223 467.126 68.8223H412.985C402.912 68.8223 394.728 75.7473 391.58 84.561L384.026 107.854C375.841 111.002 370.176 119.816 370.176 128.63V171.439C370.176 179.623 376.471 186.548 384.655 187.178C392.839 187.807 400.394 181.512 401.653 173.328H419.28V147.516C419.28 144.368 420.54 141.85 423.058 139.961C424.946 137.443 427.465 136.184 430.612 136.184H510.565V128.63Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M429.353 163.884C429.353 158.218 432.501 151.923 433.76 150.664C436.908 147.516 444.462 145.627 446.981 145.627C453.276 145.627 458.942 148.775 460.831 150.664C463.979 153.812 465.238 160.737 465.238 163.884C465.238 167.662 463.979 172.068 463.349 173.328C462.09 176.475 458.942 178.994 457.053 179.623C454.535 180.882 449.499 182.141 447.61 182.141C443.833 182.141 439.426 180.882 438.167 180.253C435.649 178.994 432.501 175.216 431.871 173.957C429.983 171.439 429.353 165.773 429.353 163.884Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M440.056 163.884C440.056 167.662 441.315 170.809 441.944 171.439C443.203 173.328 446.351 173.957 446.981 173.957C449.499 173.957 452.017 172.068 452.647 171.439C453.906 170.18 454.535 165.143 454.535 163.255C454.535 160.107 453.276 156.959 452.647 156.33C451.388 155.071 448.24 153.812 446.981 153.812C445.092 153.812 442.574 155.7 441.944 156.33C440.685 157.589 440.056 161.996 440.056 163.884Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M522.527 173.328H520.009V154.441H522.527C524.415 154.441 526.934 155.071 528.193 156.33C530.081 158.848 530.711 161.366 530.081 163.884C530.081 165.773 530.081 168.291 529.452 170.18C528.822 170.809 528.193 172.069 526.934 172.698C525.674 173.328 523.786 173.328 522.527 173.328Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M491.049 146.257H470.904V181.512H489.79C490.42 181.512 493.567 180.882 494.197 180.882C496.086 180.253 497.974 179.623 498.604 179.623C499.863 178.994 501.752 177.105 501.752 176.475C503.011 174.587 503.011 172.069 503.011 171.439C503.011 168.921 502.381 166.403 501.752 165.773C500.492 164.514 497.345 163.255 496.086 162.625C497.345 161.996 499.233 160.737 499.863 160.107C501.122 158.848 501.752 156.33 501.752 155.071C501.752 152.552 499.863 150.034 499.233 148.775C497.345 147.516 492.938 146.257 491.049 146.257Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M486.642 160.107H482.235V153.182H486.642C488.531 153.182 489.79 153.812 490.42 154.441C491.049 155.071 491.049 156.33 491.049 156.959C491.049 157.589 490.42 158.848 490.42 159.478C489.161 159.478 487.272 160.107 486.642 160.107Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M487.272 173.957H482.235V166.403H487.272C489.161 166.403 491.049 167.032 491.679 167.662C492.308 168.291 492.308 169.55 492.308 170.18C492.308 171.439 491.679 172.698 491.679 172.698C490.42 173.328 488.531 173.957 487.272 173.957Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M525.045 146.257H509.306V181.512H525.045C526.934 181.512 530.081 180.882 531.34 180.253C533.229 179.623 535.747 178.364 536.377 177.734C537.636 175.846 539.525 173.328 539.525 172.069C540.784 170.18 540.784 165.773 540.784 163.884C540.784 161.366 540.154 158.218 540.154 156.959C539.525 155.071 538.265 151.923 537.636 151.293C536.377 150.034 533.859 148.146 532.6 147.516C530.711 146.887 526.304 146.257 525.045 146.257Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M546.45 180.253C546.45 184.66 542.043 187.178 539.525 187.178C503.64 187.178 448.869 187.178 430.612 187.178C426.206 187.178 423.687 182.771 423.687 180.253C423.687 170.18 423.687 153.182 423.687 147.516C423.687 143.109 428.724 140.591 430.612 140.591C444.462 140.591 509.936 140.591 539.525 140.591C544.561 140.591 546.45 145.627 546.45 147.516C546.45 158.848 546.45 175.216 546.45 180.253Z"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M457.053 136.184V131.148H421.799V141.221"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M484.124 136.184C483.495 133.036 480.347 131.148 476.57 131.148C473.422 131.148 470.274 133.036 469.015 136.184"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M419.28 156.959H392.839C389.062 156.959 385.914 153.812 385.914 150.034C385.914 143.739 385.914 132.407 385.914 128.63C385.914 124.223 390.321 121.704 392.839 121.704C424.317 121.704 472.163 121.704 487.901 121.704C492.308 121.704 494.827 126.741 494.827 128.63C494.827 131.148 494.827 134.925 494.827 136.184"
                      stroke="#8F8C85"
                      strokeWidth="3.14775"
                      strokeMiterlimit="2.61313"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M96.3212 121.704C96.3212 122.334 95.6917 123.593 95.0621 124.223C93.803 124.852 93.1735 125.482 91.9144 125.482C89.3962 125.482 87.5075 124.223 87.5075 121.704C87.5075 119.186 88.7666 117.927 91.9144 117.927C94.4326 117.927 96.3212 119.186 96.3212 121.704ZM209.011 141.221H202.715V103.447H209.011V141.221ZM194.531 131.777C194.531 134.925 193.902 136.814 192.642 138.702C191.383 140.591 188.865 141.85 186.347 141.85C183.199 141.85 180.681 140.591 178.163 138.073C176.274 140.591 173.756 141.85 171.238 141.85C168.72 141.85 165.572 140.591 163.054 137.443C160.535 139.961 158.017 141.221 155.499 141.221H151.092H147.944C144.797 140.591 142.278 139.332 140.39 136.814C139.131 139.961 136.612 141.221 132.206 141.221H118.985H115.208V140.591C113.949 139.961 113.319 139.332 112.69 138.702C112.69 143.109 111.43 147.516 108.912 150.664C106.394 154.441 102.617 155.7 97.5803 155.7H88.7666C84.9893 155.7 81.212 154.441 78.6938 151.293C76.1756 148.775 74.9165 144.998 74.9165 141.221V128.63H80.5825V141.85C80.5825 144.368 81.212 146.257 83.1007 147.516C84.9893 149.405 87.5075 150.034 90.0257 150.034H97.5803C100.099 150.034 101.987 149.405 103.876 147.516C105.764 146.257 106.394 144.368 106.394 141.85V122.964H112.69V131.148C112.69 134.295 114.578 135.555 118.985 135.555H132.835C134.094 135.555 134.724 134.295 134.724 132.407C134.724 131.777 134.724 131.148 134.094 130.518L118.985 114.779L117.726 107.854L139.131 100.3L140.39 105.966L124.651 111.632L141.019 129.889C142.908 131.777 144.167 133.036 145.426 133.666C146.685 134.925 148.574 135.555 151.092 135.555H154.869C158.017 135.555 159.276 133.666 159.276 131.148V122.964H164.942V131.777C164.942 133.036 165.572 134.295 166.201 134.925C167.46 136.184 168.72 136.184 169.979 136.184C172.497 136.184 173.756 134.925 173.756 132.407V122.964H179.422V131.777C179.422 133.036 180.051 134.295 181.311 134.925C181.94 136.184 183.199 136.184 184.458 136.184C187.606 136.184 188.865 134.925 188.865 132.407V122.964H194.531V131.777Z"
                      fill="#8F8C85"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_50_37">
                      <rect width="588" height="256" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <span className="absolute left-[27vw] top-[4vw] text-[#02161D] bg-color-primary-B px-[0.9vw] text-[2.5vw] rounded-[1vw] font-font_primary_A font-black">
                به زودی
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-start w-[92.68867924528302vw] top-0 py-[4.919811320754717vw] mt-[3.7vw]  overflow-auto ">
            <div className="absolute w-[92.68867924528302vw]  bg-[#04181F] opacity-80 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] bottom-[0vw] top-[23vw]"></div>
            <div className="relative flex items-start justify-end w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.5vw]  ">
              <span className="absolute top-0 right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw] ">
                برند
              </span>

              <div dir="ltr" className=" w-[72vw]  top-0 left-0 ">
                <BrandSelect setBrand={setBrand} />
              </div>
            </div>
            <div className="relative flex items-start justify-end  w-[82.95047169811321vw] h-[13.07547169811321vw] mt-[3.7vw] min-h-[13.5vw]  ">
              <span className="absolute top-0 right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                مدل
              </span>

              <div dir="ltr" className=" w-[72vw] top-0 left-0 ">
                <ModelSelect
                  setModel={setModel}
                  setCategoryID={setCategoryID}
                />
              </div>
            </div>
            <div className="relative flex items-start justify-end  w-[82.95047169811321vw] h-[13.07547169811321vw] mt-[1.8vw] min-h-[13.5vw]  ">
              <span
                className="absolute top-0 right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw] "
                onClick={() => {
                  datePickerRefPr?.current?.openCalendar();
                }}
              >
                سال تولید
              </span>
              <div
                className="w-full   flex items-center justify-end  border-b-[1px] border-color-primary-D"
                onClick={() => {
                  datePickerRefPr?.current?.openCalendar();
                }}
              >
                <DatePicker
                  renderButton={(direction, handleClick) => (
                    <button
                      className="text-color-primary-D mx-[3vw] text-[5vw]"
                      onClick={handleClick}
                    >
                      {direction === "right" ? ">" : "<"}
                    </button>
                  )}
                  formatMonth={(month, year) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A ">
                        {month}
                      </span>
                    );
                  }}
                  formatYear={(year, month) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A ">
                        {year}
                      </span>
                    );
                  }}
                  highlightToday={false}
                  onOpenPickNewDate={false}
                  monthYearSeparator="|"
                  ref={datePickerRefPr}
                  minDate={`${
                    prDatePickerCalender === persian ? "1330" : "1950"
                  }`}
                  maxDate={`${
                    prDatePickerCalender === persian
                      ? new Date().getFullYear() - 619
                      : new Date().getFullYear() + 1
                  }`}
                  digits={digits}
                  onlyYearPicker={true}
                  style={{
                    backgroundColor: "transparent",
                    height: "24px",
                    width: "82vw",
                    border: "none",
                    color: "white",
                    textAlign: "left",
                    fontFamily: "dateFonts",
                    fontSize: "4vw",
                    padding: "0",
                  }}
                  className="rmdp-mobile react-datepicker "
                  mobileLabels={{
                    OK: "ثبت",
                    CANCEL: "بستن",
                  }}
                  calendar={prDatePickerCalender}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  value={prDateValue}
                  onChange={setPrDateValue}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div className="w-full  font-font_primary_A flex items-center justify-center gap-x-[8vw] text-white ">
                    <button
                      className={`border-[1px] border-color-primary-D px-[4vw] rounded-[1.8vw] ${
                        prDatePickerCalender === ""
                          ? "bg-color-primary-D text-black rounded-[1.8vw] flex items-center justify-center "
                          : ""
                      }`}
                      onClick={() => setPrDatePickerCalender("")}
                    >
                      میلادی
                    </button>
                    <button
                      className={`border-[1px] border-color-primary-D px-[4vw] rounded-[1.8vw] ${
                        prDatePickerCalender === persian
                          ? "bg-color-primary-D text-black rounded-[1.8vw] flex items-center justify-center "
                          : ""
                      }`}
                      onClick={() => setPrDatePickerCalender(persian)}
                    >
                      شمسی
                    </button>
                  </div>
                </DatePicker>
              </div>
            </div>
            <div className="relative flex items-start justify-end w-[82.95047169811321vw] h-[13.07547169811321vw] mt-[1.8vw] min-h-[13.5vw] ">
              <span className="absolute top-0 right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                کارکرد
              </span>
              <input
                type="text"
                dir="ltr"
                value={func}
                maxLength={7}
                className="relative w-[82.95047169811321vw]  text-left bg-transparent border-b-[1px] border-color-primary-D outline-none text-color-primary-A focus:text-color-primary-A text-[4.5vw] focus:text-[4.5vw] font-font_primary_D focus:font-font_primary_D leading-[6vw]"
                onChange={(e) => {
                  setFunc(addCommas(removeNonNumeric(p2e(e.target.value))));
                }}
              />
            </div>

            <div className="relative flex items-start justify-end w-[82.95047169811321vw] h-[13.07547169811321vw] mt-[1.8vw] min-h-[13.5vw] ">
              <span className="absolute top-0 right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                کیلومتر آخرین سرویس
              </span>
              <input
                type="text"
                dir="ltr"
                value={lastReplace}
                maxLength={7}
                className="relative w-[82.95047169811321vw]  text-left bg-transparent border-b-[1px] border-color-primary-D outline-none text-color-primary-A focus:text-color-primary-A text-[4.5vw] focus:text-[4.5vw] font-font_primary_D focus:font-font_primary_D leading-[6vw]"
                onChange={(e) => {
                  setLastReplace(
                    addCommas(removeNonNumeric(p2e(e.target.value)))
                  );
                }}
              />
            </div>
            <div className="relative flex items-start justify-end w-[82.95047169811321vw] h-[13.07547169811321vw] mt-[1.8vw] min-h-[13.5vw]  ">
              <span
                className="absolute top-0 right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw]"
                onClick={() => {
                  datePickerRefInsurance?.current?.openCalendar();
                }}
              >
                تاریخ انقضا بیمه شخص ثالث
              </span>
              <div
                className="w-full   flex items-center justify-end  border-b-[1px] border-color-primary-D "
                onClick={() => {
                  datePickerRefInsurance?.current?.openCalendar();
                }}
              >
                <DatePicker
                  renderButton={(direction, handleClick) => (
                    <button
                      className="text-color-primary-D mx-[3vw] text-[5vw]  z-50"
                      onClick={handleClick}
                    >
                      {direction === "right" ? ">" : "<"}
                    </button>
                  )}
                  formatMonth={(month, year) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A ">
                        {month}
                      </span>
                    );
                  }}
                  formatYear={(year, month) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A ">
                        {year}
                      </span>
                    );
                  }}
                  highlightToday={false}
                  onOpenPickNewDate={false}
                  mapDays={({
                    date,
                    today,
                    selectedDate,
                    currentMonth,
                    isSameDate,
                  }) => {
                    let props = {};

                    props.style = {
                      borderRadius: "3px",
                      color: "white",
                    };
                    if (isSameDate(date, selectedDate))
                      props.style = {
                        ...props.style,
                        color: "#000000",
                        backgroundColor: "#00F7FF",
                        fontWeight: "bold",
                        border: "1px solid #00F7FF",
                      };

                    return props;
                  }}
                  monthYearSeparator="|"
                  ref={datePickerRefInsurance}
                  minDate="1402/01/01"
                  maxDate="1403/12/30"
                  digits={digits}
                  style={{
                    backgroundColor: "transparent",
                    height: "24px",
                    width: "82vw",
                    border: "none",
                    color: "white",
                    textAlign: "left",
                    fontFamily: "dateFonts",
                    fontSize: "4.5vw",
                    padding: "0",
                  }}
                  className="rmdp-mobile react-datepicker "
                  mobileLabels={{
                    OK: "ثبت",
                    CANCEL: "بستن",
                  }}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  value={insuranceDateValue}
                  onChange={(e) => {
                    setMustSendInsuranceDate(() => {
                      let x = e?.year;
                      let y = e?.month?.number;
                      let z = e?.day;
                      if (y < 10) {
                        y = "0" + y;
                      }
                      if (z < 10) {
                        z = "0" + z;
                      }
                      return `${x}-${y}-${z}`;
                    });
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" w-full absolute bottom-[3.681603773584906vw] flex items-center justify-center">
        {isLoading ? (
          <>
            <div className="w-[92.68867924528302vw] h-[16.9811320754717vw]  bg-[#001D26]  opacity-70  border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A ">
              <BlueLoader position="" width={14} />
            </div>
          </>
        ) : (
          <>
            <button
              className="w-[92.68867924528302vw] h-[16.9811320754717vw]  bg-[#001D26]  opacity-70  border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[7.547169811320755vw]"
              onClick={rgNewCar}
            >
              ثبت
            </button>
          </>
        )}
      </div>
    </>
  );
}
